<div class="toc-layout-main">
  <ul class="dfwp-list">
    <!--MY_REQUESTS-->
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="!IsAdmin && !NavigationRequests">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/myRequests">{{'FRONT_USER.WORKSPACE.MY_REQUESTS' | translate }}</a></span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="!IsAdmin && NavigationRequests">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/NavigationRequests">{{'FRONT_USER.WORKSPACE.MY_Navigation_REQUESTS' | translate }}</a></span>
      </div>
    </li>
    <!--MY_TASKS-->
    <li class="level-section level-item-pos level-item level-bullet"
      *ngIf="!IsLongHaulManageandReportsOnly && !IsSmallUnitsAdminOnly && !IsCircularReportAdminOnly">
      <span class="notificationAlert" *ngIf="myNotifications?.PendingTasksCount > 0">
        {{myNotifications?.PendingTasksCount > 99 ? "+99" : myNotifications?.PendingTasksCount}}
      </span>
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/myTasks">
            {{'FRONT_USER.WORKSPACE.MY_TASKS' | translate }}
          </a>
        </span>
      </div>
    </li>

    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsCircularAdmin">
      <span class="notificationAlert" *ngIf="myNotifications?.CircularsPendingTasksCount > 0">
        {{myNotifications?.CircularsPendingTasksCount > 99 ? "+99" : myNotifications?.CircularsPendingTasksCount}}
      </span>
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/CircularsTasksDirectory">
            {{'FRONT_USER.WORKSPACE.Circulars_TASKS' | translate }}
          </a>
        </span>
      </div>
    </li>
    <!--Small Units_TASKS-->
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsSmallUnitsAdmin">
      <span class="notificationAlert" *ngIf="myNotifications?.SmallUnitsPendingTasksCount > 0">
        {{myNotifications?.SmallUnitsPendingTasksCount > 99 ? "+99" : myNotifications?.SmallUnitsPendingTasksCount}}
      </span>
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/SmallUnitsTasks">
            {{'FRONT_USER.WORKSPACE.SmallUnits_TASKS' | translate }}
          </a>
        </span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet"
      *ngIf="!IsLongHaulManageandReportsOnly && !IsCircularReportAdminOnly">
      <span class="notificationAlert" *ngIf="myNotifications?.UnReadMessagesCount > 0">
        {{myNotifications?.UnReadMessagesCount > 99 ? "+99" : myNotifications?.UnReadMessagesCount}}
      </span>
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/AllMessages">{{'FRONT_USER.WORKSPACE.MY_MESSAGES' | translate }}</a>
        </span>
      </div>
    </li>

    <!--CrewChange_TASKS-->
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsChangeCrewAdmin">
      <span class="notificationAlert" *ngIf="myNotifications?.ChangeCrewPendingTasksCount > 0">
        {{myNotifications?.ChangeCrewPendingTasksCount > 99 ? "+99" : myNotifications?.ChangeCrewPendingTasksCount}}
      </span>
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/CrewChangeTasks">
            {{'FRONT_USER.WORKSPACE.ChangeCrew_TASKS' | translate }}
          </a>
        </span>
      </div>
    </li>

    <!-- <li class="level-section level-item-pos level-item level-bullet" *ngIf="!IsLongHaulManageandReportsOnly && !IsCircularReportAdminOnly">
        <span class="notificationAlert" *ngIf="myNotifications?.UnReadMessagesCount > 0">
           {{myNotifications?.UnReadMessagesCount > 99 ? "+99" : myNotifications?.UnReadMessagesCount}}
        </span>
        <div class="level-header">
           <span class="headertitle headermarker">
              <a routerLink="/UnreadMessages">{{'FRONT_USER.WORKSPACE.MY_Unread_MESSAGES' | translate }}</a>
           </span>
        </div>
     </li>
      <!--MY_MESSAGES
      <li class="level-section level-item-pos level-item level-bullet" *ngIf="!IsLongHaulManageandReportsOnly && !IsCircularReportAdminOnly">
         <span class="notificationAlert" *ngIf="myNotifications?.UnReadMessagesCount > 0">
            {{myNotifications?.UnReadMessagesCount > 99 ? "+99" : myNotifications?.UnReadMessagesCount}}
         </span>
         <div class="level-header">
            <span class="headertitle headermarker">
               <a routerLink="/myMessages">{{'FRONT_USER.WORKSPACE.MY_MESSAGES' | translate }}</a>
            </span>
         </div>
      </li>-->
    <!--ETENDER_MESSAGES-->
    <li class="level-section level-item-pos level-item level-bullet"
      *ngIf="(!IsAdmin && registerationType==RegisterType.Supplier) || IsETenderAdmin">
      <span class="notificationAlert" *ngIf="myNotifications?.UnReadETenderMessagesCount > 0">
        {{myNotifications?.UnReadETenderMessagesCount > 99 ? "+99" : myNotifications?.UnReadETenderMessagesCount}}
      </span>
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/etenderMessages">{{'FRONT_USER.WORKSPACE.ETENDER_MESSAGES' | translate }}</a>
        </span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet"
      *ngIf="!IsAdmin && registerationType==RegisterType.PortalUser">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/userprofile">{{'FRONT_USER.WORKSPACE.MY_PROFILE' | translate }}</a></span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsRegistrationAdmin">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/offlineRegistration">{{'FRONT_USER.WORKSPACE.OFFLINE_REGISTRATION' | translate }}</a></span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet"
      *ngIf="!IsAdmin && registerationType==RegisterType.Supplier">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/UpdateSupplier">{{'FRONT_USER.WORKSPACE.MY_PROFILE' | translate }}</a></span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsRegistrationAdmin">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/agentList">{{'FRONT_USER.WORKSPACE.OFFLINE_AGENT_LIST' | translate }}</a></span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet"
      *ngIf=" !IsAdmin && registerationType==RegisterType.Agent">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/respresentativeList">{{'FRONT_USER.WORKSPACE.REPRESENTATIVE_LIST' | translate }}</a></span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet"
      *ngIf=" !IsAdmin && registerationType==RegisterType.Agent">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/ebookingReport">{{'FRONT_USER.WORKSPACE.EBOOKING_REPORT' | translate }}</a></span>
      </div>
    </li>
    
    <!-- Ebooking Tasks -->
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsEbookingAdmin">
      <span class="notificationAlert" *ngIf="myNotifications?.EbookingPendingTasksCount > 0">
        {{myNotifications?.EbookingPendingTasksCount > 99 ? "+99" : myNotifications?.EbookingPendingTasksCount}}
      </span>
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/ebookingTasks">
            {{'FRONT_USER.WORKSPACE.EBOOKING_TASKS' | translate }}
          </a>
        </span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsEbookingAdmin">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/ebookingReport">{{'FRONT_USER.WORKSPACE.EBOOKING_REPORT' | translate }}</a></span>
      </div>
    </li>

    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsEbookingAdmin">
      <span class="notificationAlert" *ngIf="incompleteTasksCount > 0">
        {{incompleteTasksCount > 99 ? "+99" : incompleteTasksCount}}
      </span>
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/incompleteTasks">{{'FRONT_USER.WORKSPACE.INCOMPLETE_TASKS' | translate }}</a></span>
      </div>
    </li>
    <!--Small Units Report-->
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsSmallUnitsAdmin">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/SmallUnitsReport">
            {{'FRONT_USER.WORKSPACE.SMALLUNITS_REPORT' | translate }}
          </a>
        </span>
      </div>
    </li>

    <!-- Crew Change Reports -->
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsChangeCrewAdmin">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/CrewChangeReport">
            {{'FRONT_USER.WORKSPACE.ChangeCrew_REPORT' | translate }}
          </a>
        </span>
      </div>
    </li>


    <li class="level-section level-item-pos level-item level-bullet"
      *ngIf="!IsAdmin && registerationType==RegisterType.Agent">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/updateAgentProfile">{{'FRONT_USER.WORKSPACE.MY_PROFILE' | translate }}</a></span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsSupplierAdmin">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/SupplierList">{{'FRONT_USER.WORKSPACE.SUPPLIERLIST' | translate }}</a></span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="creator==true">
      <div class="level-header">
        <span class="headertitle headermarker"><a
            routerLink="/CreateTender">{{'ADMIN_USER.E_TENDER_FORM.TENDER_CREATION' | translate}}</a><br></span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsSupplierAdmin">
      <div class="level-header">
        <span class="headertitle headermarker"><a routerLink="/TenderList">{{'FRONT_USER.SERVICES.TENDERS' |
            translate}}</a><br></span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsSupplierAdmin">
      <div class="level-header">
        <span class="headertitle headermarker"><a
            routerLink="/etenderSupplierEvaluationList">{{'FRONT_USER.SERVICES.TENDERSEVALUATIONLIST' |
            translate}}</a><br></span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsSupplierAdmin">
      <div class="level-header">
        <span class="headertitle headermarker"><a
            routerLink="/BidSupplierSubscriptionReport">{{'ADMIN_USER.E_TENDER_FORM.BID_SUPPLIERS_SUBSCRIPTIONS_LISTING'
            | translate}}</a><br></span>
      </div>
    </li>
    <!-- Long Haul Requests Management -->
    <li class="level-section level-item-pos level-item level-bullet"
      *ngIf="IsLongHaulAdmin || IsLongHaulManageandReportsOnly">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/RebateRequest/RequestsManagement">Long Haul Requests Management</a></span>
      </div>
    </li>
    <!-- Long Haul Reports -->
    <li class="level-section level-item-pos level-item level-bullet"
      *ngIf="IsLongHaulAdmin || IsLongHaulReportAdmin ||  IsLongHaulManageandReportsOnly">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/longHaulReport">Long Haul Reports</a></span>
      </div>
    </li>

    <!-- Circular Reports -->
    <li class="level-section level-item-pos level-item level-bullet"
      *ngIf="IsCircularReportAdmin || IsCircularReportAdminOnly || IsCircularAdmin">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/CircularsReport">{{'FRONT_USER.WORKSPACE.CIRCULARS_REPORT' | translate }}</a></span>
      </div>
    </li>
    <!-- shipyard report -->
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="isShipyardAdmin">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/shipyardReport">{{'FRONT_USER.WORKSPACE.SHIPYARD_REPORT' | translate}}</a><br>
        </span>
      </div>
    </li>
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsReleaseAdmin">
      <span class="notificationAlert" *ngIf="myNotifications?.ReleasePendingTasksCount > 0">
        {{myNotifications?.ReleasePendingTasksCount > 99 ? "+99" : myNotifications?.ReleasePendingTasksCount}}
      </span>
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/ReleaseTasks">
            {{'FRONT_USER.WORKSPACE.Release_TASKS' | translate }}
          </a>
        </span>
      </div>
    </li>
    <!-- Release Reports -->
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="IsReleaseReportAdmin">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a routerLink="/ReleaseReport">Release Reports</a></span>
      </div>
    </li>
    <!-- Agents Support -->
    <li class="level-section level-item-pos level-item level-bullet" *ngIf="!IsAdmin">
      <div class="level-header">
        <span class="headertitle headermarker">
          <a href="https://t.me/+lSKGsjMDsHllZjNk" target="_blank">{{'FRONT_USER.WORKSPACE.SUPPORT' | translate
            }}</a></span>
      </div>
    </li>
  </ul>
</div>
